import React from 'react'

const BlogDisqus = () => {
  return (
    <div className='row'>
    <div id='disqus_thread'></div>
      <a href='http://disqus.com' className='dsq-brlink'>comments powered by <span className='logo-disqus'>Disqus</span></a>
    </div>

  )
}

export default BlogDisqus



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/destinations/blogDisqus.jsx